import moment from "moment"
import {majorService} from "services"
import {getProgramOfTermInfo} from "helpers/user"
import {toDateOnlyString} from "helpers/dateHelper"

export type ProgramTermDateContext = {
    currentMajorVersionId?: number | {id?: number} | null
    academicTrackId?: number | null
}

export type RelatedProgramDates = {
    startDate: string | null
    contractEndDate: string | null
    projectedEndDate: string | null
    orientationDate: string | null
}

export const EMPTY_RELATED_PROGRAM_DATES: RelatedProgramDates = {
    startDate: null,
    contractEndDate: null,
    projectedEndDate: null,
    orientationDate: null
}

/** Same logic as EditableStudentField.onChangeStartingTerm — match term program by version + track. */
export async function fetchRelatedDatesFromStartingTerm(
    termId: number | null | undefined,
    profileContext: ProgramTermDateContext
): Promise<RelatedProgramDates> {
    const relatedFields: RelatedProgramDates = {...EMPTY_RELATED_PROGRAM_DATES}
    if (!termId) {
        return relatedFields
    }
    const {data: programsOfTerms} = await majorService.getMajorByTerm([termId])
    const programByTerm = getProgramOfTermInfo(programsOfTerms, profileContext)
    if (programByTerm?.startDate) {
        relatedFields.startDate = toDateOnlyString(programByTerm.startDate)
    }
    if (programByTerm?.projectedEndDate) {
        relatedFields.contractEndDate = toDateOnlyString(programByTerm.projectedEndDate)
        relatedFields.projectedEndDate = toDateOnlyString(programByTerm.projectedEndDate)
    }
    if (programByTerm?.orientationDate) {
        relatedFields.orientationDate = toDateOnlyString(programByTerm.orientationDate)
    }
    return relatedFields
}

export const toComparableDateOnly = (date?: string | Date | null): string | null => {
    if (!date) return null
    return toDateOnlyString(date)
}

/** Show attendance-delete confirm when previous start date exists and new is strictly after it. */
export const shouldConfirmAttendanceDelete = (
    previousStartDate?: string | Date | null,
    nextStartDate?: string | Date | null
): boolean => {
    const oldDate = toComparableDateOnly(previousStartDate)
    const newDate = toComparableDateOnly(nextStartDate)
    if (!oldDate || !newDate) return false
    return moment.utc(newDate).isAfter(moment.utc(oldDate), "day")
}
